var _rect, _rect2, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTaskListIconHover = function SvgTaskListIconHover(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 28.5,
    height: 28.5,
    rx: 14.25,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 28.5,
    height: 28.5,
    rx: 14.25,
    stroke: "#E0B37F",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70137 24C8.23199 24 7.83108 23.8327 7.49866 23.4981C7.16622 23.1634 7 22.7599 7 22.2874V9.60731C7 9.13484 7.16622 8.73129 7.49866 8.39668C7.83108 8.06206 8.23199 7.89474 8.70137 7.89474H12.8896C12.9487 7.36884 13.1768 6.92158 13.5738 6.55296C13.9707 6.18432 14.4462 6 15 6C15.5599 6 16.0383 6.18432 16.4353 6.55296C16.8323 6.92158 17.0573 7.36884 17.1104 7.89474H21.2986C21.768 7.89474 22.1689 8.06206 22.5013 8.39668C22.8338 8.73129 23 9.13484 23 9.60731V22.2874C23 22.7599 22.8338 23.1634 22.5013 23.4981C22.1689 23.8327 21.768 24 21.2986 24H8.70137ZM8.70137 22.579H21.2986C21.371 22.579 21.4374 22.5486 21.4978 22.4879C21.5581 22.4271 21.5883 22.3603 21.5883 22.2874V9.60731C21.5883 9.53442 21.5581 9.46761 21.4978 9.40686C21.4374 9.34614 21.371 9.31577 21.2986 9.31577H8.70137C8.62896 9.31577 8.56258 9.34614 8.50224 9.40686C8.44191 9.46761 8.41175 9.53442 8.41175 9.60731V22.2874C8.41175 22.3603 8.44191 22.4271 8.50224 22.4879C8.56258 22.5486 8.62896 22.579 8.70137 22.579ZM10.5294 20.3381H16.647V18.917H10.5294V20.3381ZM10.5294 16.6579H19.4706V15.2369H10.5294V16.6579ZM10.5294 12.9777H19.4706V11.5567H10.5294V12.9777ZM15 8.69634C15.2039 8.69634 15.3725 8.62923 15.5059 8.49502C15.6392 8.36081 15.7059 8.19107 15.7059 7.98581C15.7059 7.78054 15.6392 7.61081 15.5059 7.4766C15.3725 7.34239 15.2039 7.27528 15 7.27528C14.7961 7.27528 14.6274 7.34239 14.4941 7.4766C14.3608 7.61081 14.2941 7.78054 14.2941 7.98581C14.2941 8.19107 14.3608 8.36081 14.4941 8.49502C14.6274 8.62923 14.7961 8.69634 15 8.69634Z",
    fill: "#E0B37F"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTaskListIconHover, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/task-list-icon-hover.de01bfcd.svg";
export { ForwardRef as ReactComponent };